import React, { useEffect, useState } from 'react';
import ActivitiesList from 'js/components-v2/pages/UserDashboard/ActivitiesList';
import DashboardPage from 'js/components-v2/pages/UserDashboard/DashboardPage';
import { makeRequest } from 'js/services/Network';
import { pick } from 'lodash';
import AppUser from 'js/stores/AppUser';
import { formatCurrency } from 'js/services/Format';
import { Link } from '@reach/router';

const Transactions = () => {
  const [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState([]);

  useEffect(async () => {
    const response = await makeRequest('transactions-dashboard-data');
    console.log(response);
    setTransactions(response.data);
    setLoading(false);
  }, []);

  return (
    <DashboardPage title='Current Transactions'>
      <div className="table-responsive transactions-table">
        {transactions.length === 0 && loading && (
            <>Loading transactions...</>
        )}
        {transactions.length === 0 && !loading && (
            <>You have no transactions in process yet.</>
        )}
        <table className="table">
          <tbody>
            {transactions.map((transaction) => {
              const { item, relation, buyer, seller, status, emphasis, uid, shipping } = transaction;
              const { alias, price, url, title } = item;

              return (
                <tr key={uid}>
                  <td>
                    <small>Order ID</small>
                    {uid}
                  </td>
                  <td>
                    {'seller' === relation ? (
                      <>
                        <small>Buyer</small>
                        {buyer}
                      </>
                    ) : (
                      <>
                        <small>Seller</small>
                        {seller}
                      </>
                    )}
                  </td>
                  <td>
                    <small>Item</small>
                    {title}
                  </td>
                  <td>
                    <small>Price</small>
                    {formatCurrency(price)}
                  </td>
                  <td>
                    <small>Shipping</small>
                    {shipping}
                  </td>
                  <td>
                    <small>Status</small>
                    <span className={`status-${emphasis}`}>{status}</span>
                  </td>
                  <td>
                    <a href={url} className="btn btn-share text-nowrap">View More</a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </DashboardPage>
  );
}

export default Transactions;
